/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as AppSignWordsRouteImport } from './routes/_app/sign-words'
import { Route as AppSignReviewRouteImport } from './routes/_app/sign-review'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppReviewRouteImport } from './routes/_app/review'
import { Route as AppObjectsRouteImport } from './routes/_app/objects'
import { Route as AppGrammarRouteImport } from './routes/_app/grammar'
import { Route as AppFingerspellingRouteImport } from './routes/_app/fingerspelling'
import { Route as AppDictationRouteImport } from './routes/_app/dictation'
import { Route as AppSignWordsCodeRouteImport } from './routes/_app/sign-words_.$code'
import { Route as AppFingerspellingDrillRouteImport } from './routes/_app/fingerspelling_.drill'
import { Route as AppDictationSignRouteImport } from './routes/_app/dictation_.sign'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSignWordsRoute = AppSignWordsRouteImport.update({
  id: '/sign-words',
  path: '/sign-words',
  getParentRoute: () => AppRoute,
} as any)
const AppSignReviewRoute = AppSignReviewRouteImport.update({
  id: '/sign-review',
  path: '/sign-review',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppReviewRoute = AppReviewRouteImport.update({
  id: '/review',
  path: '/review',
  getParentRoute: () => AppRoute,
} as any)
const AppObjectsRoute = AppObjectsRouteImport.update({
  id: '/objects',
  path: '/objects',
  getParentRoute: () => AppRoute,
} as any)
const AppGrammarRoute = AppGrammarRouteImport.update({
  id: '/grammar',
  path: '/grammar',
  getParentRoute: () => AppRoute,
} as any)
const AppFingerspellingRoute = AppFingerspellingRouteImport.update({
  id: '/fingerspelling',
  path: '/fingerspelling',
  getParentRoute: () => AppRoute,
} as any)
const AppDictationRoute = AppDictationRouteImport.update({
  id: '/dictation',
  path: '/dictation',
  getParentRoute: () => AppRoute,
} as any)
const AppSignWordsCodeRoute = AppSignWordsCodeRouteImport.update({
  id: '/sign-words_/$code',
  path: '/sign-words/$code',
  getParentRoute: () => AppRoute,
} as any)
const AppFingerspellingDrillRoute = AppFingerspellingDrillRouteImport.update({
  id: '/fingerspelling_/drill',
  path: '/fingerspelling/drill',
  getParentRoute: () => AppRoute,
} as any)
const AppDictationSignRoute = AppDictationSignRouteImport.update({
  id: '/dictation_/sign',
  path: '/dictation/sign',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/dictation': typeof AppDictationRoute
  '/fingerspelling': typeof AppFingerspellingRoute
  '/grammar': typeof AppGrammarRoute
  '/objects': typeof AppObjectsRoute
  '/review': typeof AppReviewRoute
  '/settings': typeof AppSettingsRoute
  '/sign-review': typeof AppSignReviewRoute
  '/sign-words': typeof AppSignWordsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/dictation/sign': typeof AppDictationSignRoute
  '/fingerspelling/drill': typeof AppFingerspellingDrillRoute
  '/sign-words/$code': typeof AppSignWordsCodeRoute
}
export interface FileRoutesByTo {
  '/dictation': typeof AppDictationRoute
  '/fingerspelling': typeof AppFingerspellingRoute
  '/grammar': typeof AppGrammarRoute
  '/objects': typeof AppObjectsRoute
  '/review': typeof AppReviewRoute
  '/settings': typeof AppSettingsRoute
  '/sign-review': typeof AppSignReviewRoute
  '/sign-words': typeof AppSignWordsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/': typeof AppIndexRoute
  '/dictation/sign': typeof AppDictationSignRoute
  '/fingerspelling/drill': typeof AppFingerspellingDrillRoute
  '/sign-words/$code': typeof AppSignWordsCodeRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_app/dictation': typeof AppDictationRoute
  '/_app/fingerspelling': typeof AppFingerspellingRoute
  '/_app/grammar': typeof AppGrammarRoute
  '/_app/objects': typeof AppObjectsRoute
  '/_app/review': typeof AppReviewRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_app/sign-review': typeof AppSignReviewRoute
  '/_app/sign-words': typeof AppSignWordsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/_app/': typeof AppIndexRoute
  '/_app/dictation_/sign': typeof AppDictationSignRoute
  '/_app/fingerspelling_/drill': typeof AppFingerspellingDrillRoute
  '/_app/sign-words_/$code': typeof AppSignWordsCodeRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dictation'
    | '/fingerspelling'
    | '/grammar'
    | '/objects'
    | '/review'
    | '/settings'
    | '/sign-review'
    | '/sign-words'
    | '/auth/callback'
    | '/dictation/sign'
    | '/fingerspelling/drill'
    | '/sign-words/$code'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/dictation'
    | '/fingerspelling'
    | '/grammar'
    | '/objects'
    | '/review'
    | '/settings'
    | '/sign-review'
    | '/sign-words'
    | '/auth/callback'
    | '/'
    | '/dictation/sign'
    | '/fingerspelling/drill'
    | '/sign-words/$code'
  id:
    | '__root__'
    | '/_app'
    | '/_app/dictation'
    | '/_app/fingerspelling'
    | '/_app/grammar'
    | '/_app/objects'
    | '/_app/review'
    | '/_app/settings'
    | '/_app/sign-review'
    | '/_app/sign-words'
    | '/auth/callback'
    | '/_app/'
    | '/_app/dictation_/sign'
    | '/_app/fingerspelling_/drill'
    | '/_app/sign-words_/$code'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AuthCallbackRoute: typeof AuthCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/sign-words': {
      id: '/_app/sign-words'
      path: '/sign-words'
      fullPath: '/sign-words'
      preLoaderRoute: typeof AppSignWordsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sign-review': {
      id: '/_app/sign-review'
      path: '/sign-review'
      fullPath: '/sign-review'
      preLoaderRoute: typeof AppSignReviewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/review': {
      id: '/_app/review'
      path: '/review'
      fullPath: '/review'
      preLoaderRoute: typeof AppReviewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/objects': {
      id: '/_app/objects'
      path: '/objects'
      fullPath: '/objects'
      preLoaderRoute: typeof AppObjectsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/grammar': {
      id: '/_app/grammar'
      path: '/grammar'
      fullPath: '/grammar'
      preLoaderRoute: typeof AppGrammarRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/fingerspelling': {
      id: '/_app/fingerspelling'
      path: '/fingerspelling'
      fullPath: '/fingerspelling'
      preLoaderRoute: typeof AppFingerspellingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dictation': {
      id: '/_app/dictation'
      path: '/dictation'
      fullPath: '/dictation'
      preLoaderRoute: typeof AppDictationRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sign-words_/$code': {
      id: '/_app/sign-words_/$code'
      path: '/sign-words/$code'
      fullPath: '/sign-words/$code'
      preLoaderRoute: typeof AppSignWordsCodeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/fingerspelling_/drill': {
      id: '/_app/fingerspelling_/drill'
      path: '/fingerspelling/drill'
      fullPath: '/fingerspelling/drill'
      preLoaderRoute: typeof AppFingerspellingDrillRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dictation_/sign': {
      id: '/_app/dictation_/sign'
      path: '/dictation/sign'
      fullPath: '/dictation/sign'
      preLoaderRoute: typeof AppDictationSignRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppDictationRoute: typeof AppDictationRoute
  AppFingerspellingRoute: typeof AppFingerspellingRoute
  AppGrammarRoute: typeof AppGrammarRoute
  AppObjectsRoute: typeof AppObjectsRoute
  AppReviewRoute: typeof AppReviewRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppSignReviewRoute: typeof AppSignReviewRoute
  AppSignWordsRoute: typeof AppSignWordsRoute
  AppIndexRoute: typeof AppIndexRoute
  AppDictationSignRoute: typeof AppDictationSignRoute
  AppFingerspellingDrillRoute: typeof AppFingerspellingDrillRoute
  AppSignWordsCodeRoute: typeof AppSignWordsCodeRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppDictationRoute: AppDictationRoute,
  AppFingerspellingRoute: AppFingerspellingRoute,
  AppGrammarRoute: AppGrammarRoute,
  AppObjectsRoute: AppObjectsRoute,
  AppReviewRoute: AppReviewRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppSignReviewRoute: AppSignReviewRoute,
  AppSignWordsRoute: AppSignWordsRoute,
  AppIndexRoute: AppIndexRoute,
  AppDictationSignRoute: AppDictationSignRoute,
  AppFingerspellingDrillRoute: AppFingerspellingDrillRoute,
  AppSignWordsCodeRoute: AppSignWordsCodeRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AuthCallbackRoute: AuthCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
